import React from "react";
import PropTypes from "prop-types";

import { FullWidthBannerWrapper, Banner, Header, Description } from "./style";

const FullWidthBanner = (props) => {
	const { header, description, fontColor } = props;
	return (
		<FullWidthBannerWrapper>
			<Banner>
				{header && <Header fontColor={fontColor}>{header}</Header>}
				{description && (
					<Description
						fontColor={fontColor}
						dangerouslySetInnerHTML={{
							__html: description,
						}}
					/>
				)}
			</Banner>
		</FullWidthBannerWrapper>
	);
};

FullWidthBanner.propTypes = {
	header: PropTypes.string.isRequired,
	description: PropTypes.string,
	fontColor: PropTypes.string,
};

FullWidthBanner.defaultProps = {
	description: "",
	fontColor: "",
};

export default FullWidthBanner;
